var map = {
	"./form-block.tpl": 44177,
	"./form-block.tpl.html": 44177,
	"./html-block": 44984,
	"./html-block.js": 44984,
	"./html-block.tpl": 95353,
	"./html-block.tpl.html": 95353,
	"./survey-block.tpl": 70305,
	"./survey-block.tpl.html": 70305,
	"stand-alone/blocks/components/html-block/form-block.tpl": 44177,
	"stand-alone/blocks/components/html-block/form-block.tpl.html": 44177,
	"stand-alone/blocks/components/html-block/html-block": 44984,
	"stand-alone/blocks/components/html-block/html-block.js": 44984,
	"stand-alone/blocks/components/html-block/html-block.tpl": 95353,
	"stand-alone/blocks/components/html-block/html-block.tpl.html": 95353,
	"stand-alone/blocks/components/html-block/survey-block.tpl": 70305,
	"stand-alone/blocks/components/html-block/survey-block.tpl.html": 70305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21634;